module.exports = __webpack_public_path__ + "static/media/search.d4264a43.svg";